import React, {useEffect} from 'react';
import {useQueryClient} from './react-query';

type Props = {
  sideEffects?: {
    queries?: {
      onSuccess?: (data: unknown) => void;
      onError?: (error: unknown) => void;
    };
    mutations?: {
      onSuccess?: (data: unknown) => void;
      onError?: (error: unknown) => void;
    };
  };
};

export const DataFetcherSideEffects: React.FC<
  React.PropsWithChildren<Props>
> = ({children, sideEffects}) => {
  const queryClient = useQueryClient();

  // eslint-disable-next-line local-rules/too-complex-useeffects
  useEffect(() => {
    if (sideEffects?.queries) {
      const queryCache = queryClient.getQueryCache();

      queryCache.config.onSuccess = sideEffects.queries.onSuccess;
      queryCache.config.onError = sideEffects.queries.onError;
    }
    if (sideEffects?.mutations) {
      const mutationCache = queryClient.getMutationCache();

      mutationCache.config.onSuccess = sideEffects.mutations.onSuccess;
      mutationCache.config.onError = sideEffects.mutations.onError;
    }
  }, [queryClient, sideEffects?.mutations, sideEffects?.queries]);

  return <>{children}</>;
};
